module.exports = __webpack_public_path__ + "img/reject_message_example_1.42785060.png";